// /dashboard/:orgSlug/install — Figma frame 17 install (33:775).
// Owner: screens-ops, US-130.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { InstallScreen } from "../screens/ops/InstallScreen";

export const installRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/install",
  staticData: { title: "Install" },
  component: InstallRoute,
});

function InstallRoute() {
  const { orgSlug } = installRoute.useParams();
  return (
    <InstallScreen orgSlug={orgSlug} />
  );
}
